import React, { useState } from 'react';

function Dashboard() {
  const [campaigns] = useState([
    { id: 1, name: 'Kampania 1', startTime: '09:00', endTime: '17:00', status: 'active' },
    { id: 2, name: 'Kampania 2', startTime: '10:00', endTime: '18:00', status: 'inactive' },
  ]);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-4">Aktywne kampanie</h2>
          <div className="space-y-4">
            {campaigns.map(campaign => (
              <div key={campaign.id} className="border-b pb-4">
                <h3 className="font-medium">{campaign.name}</h3>
                <p className="text-sm text-gray-600">
                  {campaign.startTime} - {campaign.endTime}
                </p>
                <span className={`inline-block px-2 py-1 text-xs rounded ${
                  campaign.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                }`}>
                  {campaign.status === 'active' ? 'Aktywna' : 'Nieaktywna'}
                </span>
              </div>
            ))}
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-4">Statystyki</h2>
          <div className="grid grid-cols-2 gap-4">
            <div className="p-4 bg-gray-50 rounded">
              <p className="text-sm text-gray-600">Aktywne kampanie</p>
              <p className="text-2xl font-bold">{campaigns.filter(c => c.status === 'active').length}</p>
            </div>
            <div className="p-4 bg-gray-50 rounded">
              <p className="text-sm text-gray-600">Wszystkie kampanie</p>
              <p className="text-2xl font-bold">{campaigns.length}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;